var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2994_23550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33988 18.7458H3.35938C3.14465 18.7458 2.96875 18.57 2.96875 18.3552V4.99591M2.96875 4.99591L6.87512 1.08954M2.96875 4.99591L6.48449 4.99591C6.6993 4.99591 6.87512 4.82013 6.87512 4.60532L6.87512 1.08954M6.87512 1.08954H16.6406C16.8555 1.08954 17.0313 1.26544 17.0313 1.48016V18.3552C17.0313 18.57 16.8555 18.7458 16.6406 18.7458H11.6895M7.07046 8.51168H14.6875M5.3125 10.2695H14.6875M5.3125 6.7538H14.6875M5.3125 12.0274H10M10.2803 14.0962L12.6125 16.4283C12.7673 16.5831 12.7673 16.8341 12.6125 16.989C12.5351 17.0663 12.4336 17.105 12.3321 17.105H11.5625V19.9178C11.5625 20.1324 11.3866 20.3084 11.1719 20.3084H8.82816C8.61351 20.3084 8.43753 20.1326 8.43753 19.9178V17.1051H7.66792C7.44898 17.1051 7.27148 16.9276 7.27148 16.7086C7.27148 16.5982 7.31671 16.4982 7.3896 16.4263L9.71968 14.0962C9.87452 13.9414 10.1255 13.9414 10.2803 14.0962Z",
    stroke: "#706F7B",
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2994_23550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.699036)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.e200f11aab5eb54c31c235e05063cf2c.svg";
export { ForwardRef as ReactComponent };